import { SET_DOCTORS, UPDATE_DOCTORS, SET_PHONE } from '../actionTypes';

// 初始状态，包含医生列表
const initialState = {
    doctors: [],
};

// 医生 reducer 函数
const doctorReducer = (state = initialState, action) => {
    switch (action.type) {
        // 设置医生列表
        case SET_DOCTORS:
            return {
                ...state,
                doctors: action.payload,
            };

        // 更新医生列表
        case UPDATE_DOCTORS:
            return {
                ...state,
                doctors: state.doctors.map((doctor) => {
                    if ('count' in action.payload.updates) {
                        return action.payload.ids.includes(doctor.id)
                            ? {
                                  ...doctor,
                                  surplus:
                                      doctor.surplus +
                                      action.payload.updates.count,
                              }
                            : doctor;
                    } else {
                        return action.payload.ids.includes(doctor.id)
                            ? {
                                  ...doctor,
                                  ...action.payload.updates,
                              }
                            : doctor;
                    }
                }),
            };

        // 设置URL参数中的手机号
        case SET_PHONE:
            return {
                ...state,
                phone: action.payload,
            };

        default:
            return state;
    }
};

export default doctorReducer;
